export const SAUDI_PROVINCE_MAP: Record<string, string> = {
  Riyadh: "SA.RI",
  Makkah: "SA.MK",
  Madinah: "SA.MD",
  "Eastern Province": "SA.EP",
  Qassim: "SA.QS",
  Hail: "SA.HA",
  Tabuk: "SA.TB",
  "Northern Borders": "SA.NB",
  Jazan: "SA.JZ",
  Najran: "SA.NJ",
  "Al Bahah": "SA.BA",
  "Al Jawf": "SA.JF",
  Asir: "SA.AS",
};
